import { useAuthStore } from 'src/entities/user/store/useAuthStore';

import { ButtonV2, Typography } from '../ui';

const ImpersonationBanner = () => {
  const user = useAuthStore((state) => state.user);
  const setSelectedOrganization = useAuthStore(
    (state) => state.setSelectedOrganization
  );
  const setImpersonation = useAuthStore((state) => state.setImpersonation);

  const isArchivedOrg = user?.organizations?.some((org) => org.archived);

  const onStopImpersonation = () => {
    setImpersonation(null);
    setSelectedOrganization(null);
    window.location.href = '/';
  };

  return (
    <div className="flex items-center justify-between px-6 py-2 bg-red sticky left-0 top-0 right-0 z-[999999]">
      <div className="flex items-center gap-2">
        <Typography className="text-white" weight="bold">
          {user?.username} ({user?.id})
        </Typography>
        {isArchivedOrg && (
          <span className="bg-white text-red text-xs font-bold px-2 py-0.5 rounded">
            Archived
          </span>
        )}
        <Typography className="text-white" weight="bold">
          -
        </Typography>
        <Typography className="text-white" weight="bold">
          by: {user?.impersonating?.username} ({user?.impersonating?.id})
        </Typography>
      </div>
      <ButtonV2
        onPress={onStopImpersonation}
        className="font-semibold !px-4"
        color="secondary"
        size="sm"
      >
        Stop impersonation
      </ButtonV2>
    </div>
  );
};

export default ImpersonationBanner;
